:host {
    --wcs-footer-background-color: var(--wcs-semantic-color-background-surface-inverse);
    --wcs-footer-text-color: var(--wcs-semantic-color-text-inverse);
    --wcs-footer-link-text-color: var(--wcs-semantic-color-text-inverse);
    --wcs-footer-link-text-color-hover:  var(--wcs-semantic-color-text-inverse);
    --wcs-footer-link-font-size: var(--wcs-semantic-font-size-label-2);
    --wcs-footer-link-font-weight: var(--wcs-semantic-font-weight-medium);
    --wcs-footer-link-gap: calc(4 * var(--wcs-semantic-spacing-base));

    --wcs-footer-gap: var(--wcs-semantic-spacing-large);
    --wcs-footer-end-gap: var(--wcs-semantic-spacing-large);
    --wcs-footer-max-width: var(--wcs-semantic-breakpoint-desktop, var(--wcs-com-content-max-width));
    --wcs-footer-padding: calc(3 * var(--wcs-semantic-spacing-base));

    display: block;
    width: 100%;
    background-color: var(--wcs-footer-background-color);
    color: var(--wcs-footer-text-color);

    .end {
        margin-top: var(--wcs-footer-gap);
        gap: var(--wcs-footer-end-gap);
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: baseline;

        .end-left, .end-right {
            display: flex;
            flex-wrap: wrap;
            column-gap: var(--wcs-footer-link-gap);
        }

        @media only screen and (max-width:1024px) {
            .end-left, .end-right {
                flex-direction: column;
            }
        }

        slot[name=end-left]::slotted(a) {
            color: var(--wcs-footer-link-text-color, var(--wcs-footer-text-color));
            font-size: 14px;
            font-weight: 500;
            text-decoration: none;
        }

        slot[name=end-left]::slotted(a:hover) {
            color: var(--wcs-footer-link-text-color-hover);
        }

    }

    .container {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        max-width: var(--wcs-footer-max-width);
        padding: var(--wcs-footer-padding);
    }

}
